import React, { useState, useEffect, useContext } from 'react';
import { useCookies } from 'react-cookie';
import { GlobleContext } from './utils'
import '../App.css';
import $ from 'jquery';

const Header = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL || '/';
    const { getContactUsData, contactuseData, getProductCategoryData, productCategoryData } = useContext(GlobleContext)
    const [vskCookies, setvskCookies, removeCookie] = useCookies(['vsk_Cookie']);

    const [currentliClass, setCurrentLiClass] = useState("")
    const [curentulClass, setCurrentUlClass] = useState("")
    const handleSidebarToggle = () => {
        if (currentliClass.length) {
            setCurrentLiClass("")
            setCurrentUlClass("")
        } else {
            setCurrentLiClass("over-menu")
            setCurrentUlClass("over-submenu")
        }
    }

    useEffect(() => {
        const body = $('body');
        const offCanvasLayer = $('.close-canvas-mobile-panel');
        const navbarToggleIcon = '.navbar-toggle .navbars-icon';
        const mobileMenuToggle = 'display-mobile-menu';
        const menuItemsWithChildren = 'ul.menu li.menu-item-has-children a';
        const menu = $('#primary-mobile-nav');

        offCanvasLayer.on('click', function (e) {
            e.preventDefault();
            body.removeClass(mobileMenuToggle);
        });

        body.on('click', navbarToggleIcon, function (e) {
            e.preventDefault();
            $(this).toggleClass('selected-mobile');
            body.addClass(mobileMenuToggle);
        });

        $(menuItemsWithChildren).addClass('dropdown-toggle');

        // Additional jQuery code...
        function initializeMenu() {
            menu.find('.menu .menu-item-has-children').prepend('<span class="toggle-children "><i class="fa fa-angle-right" aria-hidden="true"></i></span>');
            menu.find('.menu .menu-item-has-children').on('click', '.toggle-children', function (e) {
                e.preventDefault();
                $(this).parent('li').addClass('over-menu');
                $(this).parents('.menu').addClass('over-submenu');
            });
            menu.find('.menu .menu-item-has-children').on('click', '.menu-back', function (e) {
                e.preventDefault();
                $(this).closest('ul').closest('li').removeClass('over-menu');
                if (!menu.find('.menu .menu-item-has-children').hasClass('over-menu')) {
                    menu.find('.menu').removeClass('over-submenu');
                }
            });
            menu.on('click', '.close-canvas-mobile-panel', function (e) {
                e.preventDefault();
                body.removeClass(mobileMenuToggle);
            });
        }

        initializeMenu();
        getProductCategoryData();
        getContactUsData();
    }, []);

    const handleMenuClick = (ProductCategoryID) => {
        // Save data in the cookie
        removeCookie('PCID')
        setvskCookies('PCID', ProductCategoryID);
    };

    return (
        <>
            <div className="preloader"></div>
            <div id="topbar" className="topbar">
                <div className="container">
                    <div className="row">
                        {contactuseData &&
                            <>
                                <div className="topbar-left topbar-widgets text-left col-md-7 col-sm-12 col-xs-12">
                                    <div id="text-8" className="widget widget_text">
                                        <div className="textwidget">
                                            <p><i className="fa fa-phone" aria-hidden="true"></i>+91 {contactuseData.MobileNo1}</p>
                                        </div>
                                    </div>
                                    {contactuseData.EmailID &&
                                        <div id="text-10" className="widget widget_text">
                                            <div className="textwidget"><i className="fa fa-envelope" aria-hidden="true"></i>{contactuseData.EmailID}</div>
                                        </div>
                                    }
                                </div>

                                <div className="topbar-right topbar-widgets text-right col-md-5 col-sm-12 col-xs-12">
                                    {(contactuseData.FacebookLink || contactuseData.TwitterLink || contactuseData.LinkedinLink || contactuseData.YoutubeLink) ?
                                        <div id="text-11" className="widget widget_text">
                                            <div className="textwidget">
                                                <p className="inlineblock"><span className="text">Stay connected:</span></p>
                                                <ul className="topbar-socials">
                                                    {contactuseData.FacebookLink &&
                                                        <li><a target='_blank' href={contactuseData.FacebookLink}><i className="fa fa-facebook" aria-hidden="true"> </i></a></li>
                                                    }
                                                    {contactuseData.TwitterLink &&
                                                        <li><a target='_blank' href={contactuseData.TwitterLink}><i className="fa fa-twitter" aria-hidden="true"> </i></a></li>
                                                    }
                                                    {contactuseData.LinkedinLink &&
                                                        <li><a target='_blank' href={contactuseData.LinkedinLink}><i className="fa fa-linkedin" aria-hidden="true"> </i></a></li>
                                                    }
                                                    {contactuseData.YoutubeLink &&
                                                        <li><a target='_blank' href={contactuseData.YoutubeLink}><i className="fa fa-youtube-play" aria-hidden="true"> </i></a></li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                        : null
                                    }
                                    <div id="search-3" className="widget widget_search">
                                        <a href='/Search' className="search-submit fp-btn">Search</a>
                                    </div>
                                </div>
                            </>
                        }
                        <div className="col-md-12">
                            <div className="topbar-border"></div>
                        </div>
                    </div>
                </div>
            </div >

            <header id="masthead" className="site-header clearfix" style={{ padding: '0px 0px' }}>
                <div id="mainWebsiteHeader" className="header-main" style={{ padding: '20px 30px 10px 30px' }}>
                    <div className="container">
                        <div className="row">
                            <div className="site-logo col-md-3 col-sm-6 col-xs-6">
                                <a href="/Splash" className="logo">
                                    <div className='divfirstlogo' style={{ background: '#fff' }}>
                                        <img src="/images/VEW_logo.png" alt="FactoryPlus" className="logo-light show-logo wblogo" />
                                        <span className='heading1 logo-light show-logo'>Vishwakarma</span><br></br>
                                        <span className='heading2 logo-light show-logo'>Engineering Works</span>

                                        <div>
                                            <span className='mobileHeader1'>Vishwakarma</span>
                                            <span className='mobileHeader1'> Engineering Works</span>
                                        </div>


                                    </div>

                                    <div className='divsecondlogo logo-dark hide-logo'>
                                        <img src="/images/VEW_logo.png" alt="FactoryPlus" className="logo-dark hide-logo wblogo" />
                                        <span className='heading3 logo-dark hide-logo'>Vishwakarma</span><br></br>
                                        <span className='heading4 logo-dark hide-logo'>Engineering Works</span>

                                        {/* <span className='mobileHeader1'>Vishwakarma Engineering Works</span>
                                        <span className='mobileHeader2'><i className='fa fa-map-marker'></i> Udhana, Surat, Gujarat</span>
                                        <span className='mobileHeader3'><i className='fa fa-check-square-o'></i> GST No. 24AHIPM6346A1ZM</span> */}

                                        <div className='divHeader2'>
                                            <p className='mobileHeader1'>Vishwakarma</p>
                                            <p className='mobileHeader1'> Engineering Works</p>
                                        </div>
                                    </div>


                                </a>
                            </div>
                            <div className="site-menu col-md-9 col-sm-6 col-xs-6">
                                <div className="navbar-toggle toggle-navs">
                                    <a className="navbars-icon">
                                        <i className="fa fa-bars" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <nav id="site-navigation" className="main-nav primary-nav nav">
                                    <ul id="primary-menu" className="menu">
                                        <li className={window.location.pathname == "/" || window.location.pathname == "/Splash" ? "current-menu-item" : ""}><a href="/Splash">Home</a>
                                        </li>
                                        {/* <li className={window.location.pathname.includes("/Product") ? "current-menu-item ourcss" : "ourcss"}><a>Our Products</a>
                                            <ul className="sub-menu">
                                                {productCategoryData &&
                                                    // console.log("sajsdhsajdahdas", productCategoryData)
                                                    productCategoryData.map((item, index) => (
                                                        <li className={window.location.pathname == `/Product/${item.ProductCategory.replace(/\s+/g, '_')}` ? "submenuactive" : ""} key={index} value={item.ProductCategoryID} onClick={() => handleMenuClick(item.ProductCategoryID)}>
                                                            <a href={`/Product/${item.ProductCategory.replace(/\s+/g, '_')}`}>
                                                                {item.ProductCategory}
                                                            </a>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </li> */}

                                        {productCategoryData.length > 0 ?
                                            <li className={window.location.pathname.includes("/Product") ? "current-menu-item" : ""}><a onClick={() => handleMenuClick(productCategoryData[0].ProductCategoryID)} href={`/Product/${productCategoryData[0].ProductCategory.replace(/\s+/g, '_')}`}>Our Products</a>
                                            </li> : null
                                        }

                                        <li className={window.location.pathname == "/CorporateBrochure" || window.location.pathname == "/CorporatePresentation" ? "current-menu-item dropdown-item" : "dropdown-item"}><a>Corporate Brochure</a>
                                            <ul className="sub-menu">
                                                <li className={window.location.pathname == "/CorporateBrochure" ? "submenuactive" : ""}><a href="/CorporateBrochure">Corporate Brochure</a></li>
                                                <li className={window.location.pathname == "/CorporatePresentation" ? "submenuactive" : ""}><a href="/CorporatePresentation">Corporate Presentation</a></li>
                                            </ul>
                                        </li>

                                        <li className={window.location.pathname == "/Infrastructure" || window.location.pathname == "/Quality" ? "current-menu-item dropdown-item" : "dropdown-item"}><a href="#">Infrastructure  </a>
                                            <ul className="sub-menu">
                                                <li className={window.location.pathname == "/Infrastructure" ? "submenuactive" : ""}><a href="/Infrastructure">Infrastructure And Facilities</a></li>
                                                <li className={window.location.pathname == "/Quality" ? "submenuactive" : ""}><a href="/Quality">Quantity</a></li>
                                            </ul>
                                        </li>
                                        {/* <li className={window.location.pathname == "/DistributerEnquiry" ? "current-menu-item" : ""}><a href="/DistributerEnquiry">Distributor Enquiry</a>
                                        </li>
                                        <li className={window.location.pathname == "/ContactUs" ? "current-menu-item" : ""}><a href="/ContactUs">Contact Enquiry</a>
                                        </li> */}

                                        <li className={window.location.pathname == "/Other" || window.location.pathname == "/Certificate" ? "current-menu-item dropdown-item" : "dropdown-item"}><a href="#">Other  </a>
                                            <ul className="sub-menu">
                                                <li className={window.location.pathname == "/Certificate" ? "submenuactive" : ""}><a href="/Certificate">Certificate</a></li>
                                                <li className={window.location.pathname == "/Award" ? "submenuactive" : ""}><a href="/Award">Awards</a></li>
                                                <li className={window.location.pathname == "/Testimonial" ? "submenuactive" : ""}><a href="/Testimonial">Testimonial</a></li>
                                                <li className={window.location.pathname == "/Gallery" ? "submenuactive" : ""}><a href="/Gallery">Gallery</a></li>
                                            </ul>
                                        </li>                                     

                                        <li className={window.location.pathname == "/DistributerEnquiry" || window.location.pathname == "/ContactUs" ? "current-menu-item" : ""}><a href="#">Contact </a>
                                            <ul className="sub-menu">
                                                <li className={window.location.pathname == "/ContactUs" ? "submenuactive" : ""}><a href="/ContactUs">Contact Us</a></li>
                                                <li className={window.location.pathname == "/DistributerEnquiry" ? "submenuactive" : ""}><a href="/DistributerEnquiry">Distributor Enquiry</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='divMobileHeader2'>
                    <span className='mobileHeader2'><i className='fa fa-map-marker'></i> Udhana, Surat, Gujarat</span>
                    <span className='mobileHeader3'><i className='fa fa-check-square-o'></i> GST No. 24AHIPM6346A1ZM</span>
                </div>
            </header>


            <div className="primary-mobile-nav header-v1" id="primary-mobile-nav" role="navigation">
                <a href="#" className="close-canvas-mobile-panel">×</a>
                <ul id="primary-menu2" className={`menu ${curentulClass}`}>
                    <li className={window.location.pathname == "/" || window.location.pathname == "/Splash" ? "current-menu-item" : ""}><a href="/Splash">Home</a>
                    </li>

                    <li className={window.location.pathname.includes("/Product") ? `current-menu-item dropdown-item menu-item-has-children ${currentliClass}` : `dropdown-item menu-item-has-children ${currentliClass}`}><a className='dropdown-toggle'>Our Products</a>
                        <ul className="sub-menu">
                            {productCategoryData &&
                                productCategoryData.map((item, index) => (
                                    <li className={window.location.pathname == `/Product/${item.ProductCategory.replace(/\s+/g, '_')}` ? "submenuactive" : ""} key={index} value={item.ProductCategoryID} onClick={() => handleMenuClick(item.ProductCategoryID)}>
                                        <a href={`/Product/${item.ProductCategory.replace(/\s+/g, '_')}`}>
                                            {item.ProductCategory}
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>
                    </li>

                    <li className={window.location.pathname == "/CorporateBrochure" || window.location.pathname == "/CorporatePresentation" ? "current-menu-item dropdown-item menu-item-has-children" : "dropdown-item menu-item-has-children"}><a className='dropdown-toggle'>Corporate Brochure</a>
                        <ul className={`sub-menu`}>
                            <li className={window.location.pathname == "/CorporateBrochure" ? "submenuactive" : ""}><a href="/CorporateBrochure">Corporate Brochure</a></li>
                            <li className={window.location.pathname == "/CorporatePresentation" ? "submenuactive" : ""}><a href="/CorporatePresentation">Corporate Presentation</a></li>
                        </ul>
                    </li>

                    <li className={window.location.pathname == "/Infrastructure" || window.location.pathname == "/Quality" ? "current-menu-item dropdown-item menu-item-has-children" : "dropdown-item menu-item-has-children"}><a>Infrastructure</a>
                        <ul className="sub-menu">
                            <li className={window.location.pathname == "/Infrastructure" ? "submenuactive" : ""}><a href="/Infrastructure">Infrastructure And Facilities</a></li>
                            <li className={window.location.pathname == "/Quality" ? "submenuactive" : ""}><a href="/Quality">Quantity</a></li>
                        </ul>
                    </li>

                    <li className={window.location.pathname == "/Other" || window.location.pathname == "/Testimonial" ? "current-menu-item dropdown-item menu-item-has-children" : "dropdown-item menu-item-has-children"}><a href="#">Other  </a>
                        <ul className="sub-menu">
                            <li className={window.location.pathname == "/Certificate" ? "submenuactive" : ""}><a href="/Certificate">Certificate</a></li>
                            <li className={window.location.pathname == "/Award" ? "submenuactive" : ""}><a href="/Award">Awards</a></li>
                            <li className={window.location.pathname == "/Testimonial" ? "submenuactive" : ""}><a href="/Testimonial">Testimonial</a></li>
                            <li className={window.location.pathname == "/Gallery" ? "submenuactive" : ""}><a href="/Gallery">Gallery</a></li>
                        </ul>
                    </li>                 

                    <li className={window.location.pathname == "/DistributerEnquiry" || window.location.pathname == "/ContactUs" ? "dropdown-item menu-item-has-children current-menu-item" : "dropdown-item menu-item-has-children"}><a>Contact Us</a>
                        <ul className="sub-menu">
                            <li className={window.location.pathname == "/ContactUs" ? "submenuactive" : ""}><a href="/ContactUs">Contact Us</a></li>
                            <li className={window.location.pathname == "/DistributerEnquiry" ? "submenuactive" : ""}><a href="/DistributerEnquiry">Distributor Enquiry</a></li>
                        </ul>
                    </li>
                    <li className={window.location.pathname == "/Search" ? "current-menu-item" : ""}><a href="/Search">Search Product</a>
                    </li>
                </ul>
            </div>
            <div id="off-canvas-layer" className="off-canvas-layer"></div>
        </>
    );
};

export default Header;